/* ============================================================
   Shop by Category — section-shop-by-category.js
   Scroll-in animation only. No deps.
   ============================================================ */
(function () {
  'use strict';

  const SELECTOR = '[data-shop-by-category]';
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(root) {
    const animation = root.dataset.animation;
    if (!animation || animation === 'none' || prefersReduced) {
      root.classList.add('is-in-view');
      return;
    }
    if (!('IntersectionObserver' in window)) {
      root.classList.add('is-in-view');
      return;
    }
    const io = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );
    io.observe(root);
    root.__sbcObserver = io;
  }

  function initAll(scope) {
    const root = scope || document;
    root.querySelectorAll(SELECTOR).forEach(function (el) {
      if (!el.__sbcInitialized) {
        el.__sbcInitialized = true;
        setup(el);
      }
    });
  }

  function destroy(el) {
    if (el && el.__sbcObserver) {
      el.__sbcObserver.disconnect();
      el.__sbcObserver = null;
      el.__sbcInitialized = false;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* ---------- Shopify Theme Editor ---------- */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    const el = e.target.querySelector(SELECTOR);
    if (el) destroy(el);
  });
  document.addEventListener('shopify:section:select', function (e) {
    const el = e.target.querySelector(SELECTOR);
    if (el) el.classList.add('is-in-view');
  });
  document.addEventListener('shopify:block:select', function (e) {
    const el = e.target.closest(SELECTOR);
    if (el) el.classList.add('is-in-view');
  });
})();
